import React from 'react';
import { Button } from '@mui/material';
import Modal from 'react-bootstrap/Modal';
import { FaTrash, FaExclamationTriangle } from 'react-icons/fa';
import { Typography } from '@mui/material';

function ModalDeleteUser({ mostrar, handleClose, excluirUser, usuarioNome }) {
    
    const handleConfirmDelete = () => {
        excluirUser();
        handleClose();
    };

    return (
        <Modal show={mostrar} onHide={handleClose} centered>
            <Modal.Header closeButton style={{paddingTop: 10, paddingBottom: 10}}>
                <Modal.Title style={{
                    color: "#E34234", 
                    width: "100%", 
                    textAlign: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 10
                }}>
                    <FaExclamationTriangle size={24} />
                    Confirmar Exclusão
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{
                    marginLeft: 20,
                    marginRight: 20, 
                    marginTop: 10,
                    marginBottom: 10,
                    textAlign: 'center'
                }}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 20
                    }}>
                        <FaTrash 
                            size={48} 
                            color="#E34234" 
                            style={{ opacity: 0.7 }}
                        />
                        <Typography variant="h6" component="div" style={{
                            color: "#333",
                            marginBottom: 10
                        }}>
                            Tem certeza que deseja excluir este usuário?
                        </Typography>
                        {usuarioNome && (
                            <Typography variant="body1" component="div" style={{
                                color: "#666",
                                fontWeight: 'bold',
                                backgroundColor: '#f5f5f5',
                                padding: '10px 15px',
                                borderRadius: 8,
                                border: '1px solid #ddd'
                            }}>
                                {usuarioNome}
                            </Typography>
                        )}
                        <Typography variant="body2" component="div" style={{
                            color: "#888",
                            textAlign: 'center',
                            lineHeight: 1.5
                        }}>
                            Esta ação não pode ser desfeita. O usuário será removido permanentemente do sistema.
                        </Typography>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div onClick={handleClose}>
                    <Button 
                        style={{backgroundColor: "#a3a3a3"}} 
                        variant="contained"
                    >
                       Cancelar
                    </Button>
                </div>
                <div onClick={handleConfirmDelete}>
                    <Button 
                        style={{backgroundColor: "#E34234"}} 
                        variant="contained"
                        startIcon={<FaTrash />}
                    >
                       Excluir Usuário
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default ModalDeleteUser;